import type { Iso2 } from 'intl-tel-input/data'

// Some dialing codes are mapped to multiple countries, so we choose the most relevant ones
export const CODE_TO_COUNTRY_EXCEPTIONS: Record<number, string> = {
    1: 'US',
    7: 'RU',
    39: 'IT',
    44: 'GB',
    47: 'NO',
    61: 'AU',
    358: 'FI',
}

// ISO-639-1 to ISO-3166-1 when it's not the same
export const LOCALE_TO_COUNTRY_EXCEPTIONS: Record<string, Iso2> = {
    en: 'us',
    uk: 'ua',
}
